import { useEffect, useState } from "react";

import {
  actualizarAhora,
  alHaberActualizacion,
  aplicarActualizacion,
  destinoParaActualizar,
  hayActualizacionPendiente,
  hayAlgoSinGuardar,
} from "../../pwa";

/* El cartel de "hay una versión nueva".
 *
 * Aparece —en naranja, arriba— cuando se desplegó una versión nueva del hub,
 * SIN recargar solo ni sacar a nadie de la sesión. La persona actualiza cuando
 * quiere: con el botón (que aplica la versión nueva y recarga) o, si prefiere,
 * con Ctrl+Shift+R. Se puede cerrar y seguir trabajando con la que tiene.
 *
 * DOS AVISOS MÁS, SÓLO DE ADUANA (Fabián e Igna, 09/10: un MIC salió con la
 * casilla 27 mal desde una pestaña de la mañana). Los pide `AlDiaParaEmitir`
 * o el guardado de CRT y MIC, y se muestran aunque el cartel se hubiera
 * cerrado: ahí la versión vieja no es una pantalla que todavía no cambió, es
 * un papel que se presenta en la frontera.
 *
 *   antes-de-emitir  al entrar a CRT o MIC había versión nueva y no se pudo
 *                    recargar sola (algo a medio cargar, sin red, o ya se
 *                    intentó).
 *   tras-guardar     se acaba de guardar o emitir con la versión vieja. El
 *                    botón vuelve al papel abierto ya actualizado.
 *
 * EN ESOS DOS, EL BOTÓN PRIMERO PREGUNTA. Después de «Guardar» el formulario
 * del CRT o del MIC sigue abierto y se puede seguir tipeando; recargar ahí
 * borraría lo tipeado después de guardar. Si algo está a medio cargar
 * (`hayAlgoSinGuardar`: el formulario abierto avisa cuando difiere de lo
 * guardado), no recarga: pide guardarlo primero. El aviso de siempre sigue
 * como estaba: su recarga ya pasa por el diálogo del navegador.
 */
const TEXTO = {
  "antes-de-emitir": (
    <>
      Hay una versión nueva del Hub y esta pestaña sigue con la anterior.{" "}
      <b>Actualizá antes de emitir</b> — si tenés algo a medio cargar,
      guardalo primero.
    </>
  ),
  "tras-guardar": (
    <>
      Quedó guardado, pero con una versión vieja del Hub.{" "}
      <b>Actualizá ahora</b> —lo que guardaste no se pierde— y revisá el
      papel antes de imprimirlo.
    </>
  ),
  frenado: (
    <>
      Hay algo a medio cargar en esta pestaña. <b>Guardalo primero</b> y
      después tocá «Actualizar»: así no se pierde lo que tipeaste.
    </>
  ),
  yendo: <>Actualizando el Hub a la versión nueva…</>,
};

export default function AvisoActualizacion() {
  const [hay, setHay] = useState(hayActualizacionPendiente());
  const [cerrado, setCerrado] = useState(false);
  /* `null` = el aviso de siempre; si no, el motivo de Aduana. */
  const [aduana, setAduana] = useState(null);
  /* Con un aviso de Aduana: "frenado" si se tocó el botón con algo a medio
     cargar, "yendo" si ya está recargando. */
  const [estado, setEstado] = useState(null);

  useEffect(
    () =>
      alHaberActualizacion((info) => {
        setHay(true);
        if (info?.motivo === "antes-de-emitir" || info?.motivo === "tras-guardar") {
          setAduana(info.motivo);
          setEstado(null);
          setCerrado(false);
        }
      }),
    [],
  );

  if (!hay || cerrado) return null;

  const actualizarAduana = () => {
    if (hayAlgoSinGuardar()) {
      setEstado("frenado");
      return;
    }
    setEstado("yendo");
    actualizarAhora(destinoParaActualizar());
  };

  return (
    <div className="aviso-update" role="status">
      <span className="aviso-update-txt">
        {aduana ? (
          TEXTO[estado || aduana]
        ) : (
          <>
            Hay una versión nueva de FiBOT. Actualizá para verla — con el botón o con{" "}
            <b>Ctrl</b>+<b>Shift</b>+<b>R</b>.
          </>
        )}
      </span>
      <button
        className="aviso-update-btn"
        onClick={aduana ? actualizarAduana : () => aplicarActualizacion()}
      >
        Actualizar
      </button>
      <button
        className="aviso-update-x"
        aria-label="Cerrar el aviso"
        title="Seguir con esta versión por ahora"
        onClick={() => setCerrado(true)}
      >
        ×
      </button>
    </div>
  );
}
